import { ref, type Ref } from "vue"
import { defineStore } from "pinia"
import type { WorkPeriod } from "@/models/work-period.model.ts"

export const useWorkPeriodStore = defineStore("workPeriodStore", () => {
  // TODO consider some dynamic way to manage different workPeriods collections and counts
  // TODO this pattern is repeated in other stores and would benefit from an abstraction

  const workPeriods: Ref<WorkPeriod[]> = ref([])
  const workPeriodsBeingFetchedCount = ref(0)

  const appWorkPeriods: Ref<WorkPeriod[]> = ref([])
  const appWorkPeriodsBeingFetchedCount = ref(0)

  function clearAppWorkPeriods() {
    appWorkPeriods.value = []
  }

  return {
    workPeriods,
    workPeriodsBeingFetchedCount,
    appWorkPeriods,
    appWorkPeriodsBeingFetchedCount,
    clearAppWorkPeriods
  }
})
